// error.context.tsx
import SupportMessageModal from "@components/support/SupportMessageModal";
import React, { createContext, useContext, useEffect, useState } from "react";
import { registerErrorHandler } from "./error.service";
import ErrorModal from "@components/support/ErrorModal";

export type ErrorPayload = {
  title?: string;
  type?: string;
  reason?: string;
  solutions?: string[];
};

type ErrorContextType = {
  showError: (error: ErrorPayload) => void;
};

const ErrorContext = createContext<ErrorContextType | null>(null);

export const ErrorProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const [error, setError] = useState<ErrorPayload | null>(null);
  const [supportOpen, setSupportOpen] = useState(false);
  const showError = (payload: ErrorPayload) => {
    setError(payload);
  };

  useEffect(() => {
    registerErrorHandler(showError);
  }, []);

  const hideError = () => setError(null);

  return (
    <ErrorContext.Provider value={{ showError }}>
      {children}

      {error && !supportOpen && (
        <ErrorModal
          title={error.title}
          type={error.type}
          reason={error.reason}
          solutions={error.solutions}
          onClose={hideError}
          onOpenSupport={() => {
            setSupportOpen(true);
          }}
        />
      )}
      {supportOpen && (
        <SupportMessageModal
          value={`Bonjour,

J'ai un problème avec l'outil web Heric.

Type : ${error?.type ?? ""}
Raison : ${error?.reason ?? ""}
${(error?.solutions?.length ?? 0) > 0 ? "Solutions : " + (error?.solutions?.join(" ") ?? "") : ""}

[Ajoutez des informations supplémentaires ici.]

Merci de votre aide.`}
          onClose={() => {
            setSupportOpen(false); // ✅ Separate statements
            hideError();
          }}
        ></SupportMessageModal>
      )}
    </ErrorContext.Provider>
  );
};

export const useError = () => {
  const ctx = useContext(ErrorContext);
  if (!ctx) {
    throw new Error("useError must be used inside ErrorProvider");
  }
  return ctx;
};
